import { queryGraphQL, mutateGraphQL } from 'common/util/query';
import { toQuery, toMutation, nodeWithArgs, node } from 'common/util/queryHelper';
import { isNil } from 'lodash';
import { addApplicationMessages } from 'common/actions/applicationMessagesActions';

export const LOAD_BINDER_TEMPLATES = 'LOAD_BINDER_TEMPLATES';
export const CREATE_BINDER_SUCCESS = 'CREATE_BINDER_SUCCESS';
export const CREATE_BINDER_IN_PROGRESS = 'CREATE_BINDER_IN_PROGRESS';

export function loadBinderTemplates() {
    const query = toQuery(
        node('me', [
            node('binderTemplates', [
                'id',
                'displayName',
                'description',
                'billable',
                'binderType',
            ])
        ])
    );
    return dispatch => queryGraphQL(query)
        .then(results => dispatch(loadBinderTemplatesAction(results.data.me.binderTemplates)));

}

function loadBinderTemplatesAction(binderTemplates) {
    return {
        type: LOAD_BINDER_TEMPLATES,
        payload: binderTemplates
    };
}

function createBinderSuccessAction(binderId) {
    return {
        type: CREATE_BINDER_SUCCESS,
        payload: {
            binderId
        }
    };
}

function createBinderInProgressAction() {
    return {
        type: CREATE_BINDER_IN_PROGRESS
    };
}

export function submitCreateBinder(binder) {
    return dispatch => {
        const renewalDate = isNil(binder.renewalDate) ? null : binder.renewalDate.toString();
        const eventsTabEnabled = binder.eventsTabEnabled ? true : false;    
        let mutation = toMutation([
            nodeWithArgs('createBinder', {
                title: binder.title,
                description: binder.description,
                trialType: binder.trialType,
                binderTemplateId: binder.binderTemplateId,
                primaryInvestigator: binder.primaryInvestigator,
                irbNumber: binder.irbNumber,
                contact: binder.contact,
                trialId: binder.trialId,
                departmentSiteDg: binder.departmentSiteDg,
                ctGovNumber: binder.ctGovNumber,
                sponsorCro: binder.sponsorCro,
                renewalDate,
                eventsTabEnabled,
            })
        ]);

        dispatch(createBinderInProgressAction());
        return mutateGraphQL(mutation).then(response => {
            if (response.errors) {
                dispatch(addApplicationMessages('error', response.errors.map(e => e.message)));
            } else {
                const newBinderId = response.data.createBinder;
                dispatch(createBinderSuccessAction(newBinderId));
            }
        });
    };
}
